import React from "react";

function About() {
  return (
   <section id="about" style={styles.container}>
      <div style={styles.content}>
        <div style={styles.text}>
          <h2 style={styles.title}>About Unblemished Advocacy</h2>
          <p>
            Unblemished Advocacy is a mission-driven organization committed to promoting corruption-free living and academic integrity. We focus on reshaping mindsets through education, mentorship, and value-based guidance that inspires honesty, discipline, and ethical responsibility.

          </p>
          <p>
            Our work is rooted in the belief that a transparent and morally sound educational system is the foundation for a better society. Through consistent advocacy and spiritual grounding, we aim to nurture individuals who uphold truth and integrity in every aspect of life.
          </p>
        </div>

        <div style={styles.imageBox}>
          <img
            src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=600&auto=format&fit=crop&q=60"
            alt="About"
            style={styles.image}
            l0ading= "lazy"
            data-aos="fade-right"
          />
        </div>
      </div>
    </section>
  );
}

const styles = {
  container: {
    padding: "80px 20px",
    background: "#f4f6f9"
  },
  content: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "40px",
    flexWrap: "wrap"
  },
  text: {
    maxWidth: "600px"
  },
  title: {
    fontSize: "clamp(20px, 4vw, 32px)",
    whiteSpace: "nowrap",
    marginBottom: "15px",
  },
  imageBox: {
    maxWidth: "400px"
  },
  image: {
    width: "100%",
    borderRadius: "10px"
  }
};

export default About;